<div id="carbonAdHolder" [class.is-pulled-right-desktop]="pulledRight"></div>